exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".u-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.VHAInterface {\n  display: flex;\n  margin-top: 24px; }\n  .VHAInterface .Pane {\n    margin-bottom: 40px; }\n  .VHAInterface .SliderControl-bar {\n    background-color: #0068e9; }\n  .VHAInterface .SliderControl.mod-horizontal {\n    height: 56px; }\n  .VHAInterface .SliderControl.mod-vertical {\n    height: 160px; }\n", ""]);

// exports
